import { BaseApiServiceImpl } from "./BaseApiServiceImpl";

export interface DataBundleProduct {
  id: string;
  telco: string;
  label: string;
  validity: string;
  quantity: number;
  unit: "MB" | "GB";
  volumeMb?: number;
  amount: number;
  currency: string;
}

export interface DataCatalogueTelco {
  telco: string;
  bundles: DataBundleProduct[];
}

export interface DataBundleRecipient {
  msisdn: string;
  network: string;
  quantity: number;
  unit: string;
  validity: string;
}

export interface DataBundlePurchaseRequest {
  externalReferenceID?: string;
  Currency?: string;
  recipients: DataBundleRecipient[];
}

export interface DataBundlePurchaseResponse {
  success: boolean | string;
  message: string;
  kacyberReference: string;
  externalReferenceID: string;
  totalSent: number;
  totalFailed: number;
  totalAmount: string;
  status: string;
}

export interface DataBundleStatus {
  success: boolean | string;
  reference: string;
  externalReferenceID: string;
  transactionType: string;
  status: string;
  totalRecords: number;
  totalSuccessful: number;
  totalPending: number;
  totalFailed: number;
  totalAmount: string;
  datetime: string;
}

export class DataBundleService {
  private static baseUrl = "/api/v1/data-bundles";

  static async getCatalogue(telco?: string): Promise<DataCatalogueTelco[]> {
    const queryParameters: any = {};
    if (telco) queryParameters.telco = telco;
    const response: any = await new BaseApiServiceImpl(`${this.baseUrl}/catalogue`)
      .getRequestWithJsonResponse(queryParameters);
    return response?.data?.telcos ?? [];
  }

  static async purchaseBundles(
    request: DataBundlePurchaseRequest
  ): Promise<DataBundlePurchaseResponse> {
    const response: any = await new BaseApiServiceImpl(`${this.baseUrl}/purchase`)
      .postRequestWithJsonResponse(request);
    return response?.data ?? response;
  }

  static async checkStatus(reference: string): Promise<DataBundleStatus> {
    const response: any = await new BaseApiServiceImpl(
      `${this.baseUrl}/status/${reference}`
    ).getRequestWithJsonResponse({});
    return response?.data ?? response;
  }
}
